import { render, staticRenderFns } from "./OfficalItem.vue?vue&type=template&id=b6a6275c&scoped=true"
import script from "./OfficalItem.vue?vue&type=script&lang=js"
export * from "./OfficalItem.vue?vue&type=script&lang=js"
import style0 from "./OfficalItem.vue?vue&type=style&index=0&id=b6a6275c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a6275c",
  null
  
)

export default component.exports